export default __webpack_public_path__ + "static/media/mini-unicorn.af3d3927.svg";